import { useState, useCallback } from 'react';
import { Search, X } from 'lucide-react';

interface FavoritesSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function FavoritesSearch({
  value,
  onChange,
  placeholder = 'Search favorites...',
}: FavoritesSearchProps) {
  const [isFocused, setIsFocused] = useState(false);

  const handleClear = useCallback(() => {
    onChange('');
  }, [onChange]);

  return (
    <div className="px-4 py-3 bg-slate-50 border-b border-slate-100">
      <div
        className={`
          flex items-center gap-2 bg-white rounded-xl px-3 py-2 
          border transition-colors
          ${isFocused ? 'border-[#8e4585] ring-2 ring-[#8e4585]/20' : 'border-slate-200'}
        `}
      >
        <Search size={18} className="text-slate-400 flex-shrink-0" />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder={placeholder}
          className="flex-1 bg-transparent text-sm text-slate-700 placeholder-slate-400 focus:outline-none"
        />
        {value && (
          <button
            onClick={handleClear}
            className="p-1 text-slate-400 hover:text-slate-600 rounded-full hover:bg-slate-100 transition-colors"
            aria-label="Clear search"
          >
            <X size={14} />
          </button>
        )}
      </div>
    </div>
  );
}
